<template>
    <div id="app">
        <div v-if="!isLoginPage" class="header">
            <div class="logo_img">
                <div class="header-logo" @click="logoClick">
                    <img id="header-img" src="../assets/logo@2x.png" />
                </div>
            </div>
            <el-button v-if="!seen" class="header-login-btn" size="mini" @click="register" round
                >我要入驻</el-button
            >
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu
                    v-if="seen"
                    ref="menu"
                    :default-active="activeNavName"
                    class="el-menu-demo"
                    menu-trigger="click"
                    text-color="#333"
                    active-text-color="#2F9458"
                    style="border: 0"
                    mode="horizontal"
                    @select="handleSelect"
                >
                    <el-menu-item index="Home" key="1" class="header-title">首页</el-menu-item>
                    <el-menu-item index="Profile" key="2" class="header-title"
                        >公司简介</el-menu-item
                    >
                    <el-menu-item index="News" key="5" class="header-title">新闻中心</el-menu-item>
                    <el-menu-item v-if="false" index="Product" key="3" class="header-title"
                        >产品介绍</el-menu-item
                    >
                    <el-menu-item index="ShoppingMall" key="6" class="header-title"
                        >商城</el-menu-item
                    >
                    <el-menu-item index="Contact" key="4" class="header-title"
                        >联系我们</el-menu-item
                    >
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-dropdown
                    v-if="!seen"
                    class="el-menu-demo"
                    trigger="click"
                    @command="handleSelectMobile"
                >
                    <img src="../assets/mobile/icon_cd@2x.png" class="menu-img" />
                    <el-dropdown-menu slot="dropdown" style="padding: 0px; margin: 0">
                        <el-dropdown-item command="1" class="header-title">
                            <div class="c-menu" :class="{ 'menu-color': activeNavName === 'Home' }">
                                首页
                            </div>
                            <div class="e-menu" :class="{ 'menu-color': activeNavName === 'Home' }">
                                HOME
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item command="2" class="header-title">
                            <div
                                class="c-menu"
                                :class="{ 'menu-color': activeNavName === 'Profile' }"
                            >
                                公司简介
                            </div>
                            <div
                                class="e-menu"
                                :class="{ 'menu-color': activeNavName === 'Profile' }"
                            >
                                PROFILE
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item command="5" class="header-title">
                            <div class="c-menu" :class="{ 'menu-color': activeNavName === 'News' }">
                                新闻中心
                            </div>
                            <div class="e-menu" :class="{ 'menu-color': activeNavName === 'News' }">
                                JOURNALISM
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="false" command="3" class="header-title">
                            <div
                                class="c-menu"
                                :class="{ 'menu-color': $route.name === 'Product' }"
                            >
                                产品介绍
                            </div>
                            <div
                                class="e-menu"
                                :class="{ 'menu-color': $route.name === 'Product' }"
                            >
                                PRODUCT
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item command="6" class="header-title">
                            <div
                                class="c-menu"
                                :class="{ 'menu-color': $route.name === 'ShoppingMall' }"
                            >
                                商城
                            </div>
                            <div
                                class="e-menu"
                                :class="{ 'menu-color': $route.name === 'ShoppingMall' }"
                            >
                                SHOPPING
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item command="4" class="header-title">
                            <div
                                class="c-menu"
                                :class="{ 'menu-color': $route.name === 'Contact' }"
                            >
                                联系我们
                            </div>
                            <div
                                class="e-menu"
                                :class="{ 'menu-color': $route.name === 'Contact' }"
                            >
                                CONTACT
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="seen" class="header-login">
                <div class="phone-number">
                    <img class="phone-number-img" src="../assets/main/mobile_logo@2x.png" />
                    <span>{{ contactPhone }}</span>
                </div>
                <div
                    ref="box"
                    class="header-login-btn"
                    size="mini"
                    @click="showSelfDropMenu = !showSelfDropMenu"
                    round
                >
                    我要入驻
                </div>
                <!-- <el-dropdown trigger="click" class="header-login-dropdown" @command="handleSelectLogin">
                    <el-button class="header-login-btn" size="mini" round>我要入驻</el-button>
                    <el-dropdown-menu slot="dropdown" style="padding: 10px 0px;margin: 0;">
                        <el-dropdown-item command="1" class="login-title">工业入驻</el-dropdown-item>
                        <el-dropdown-item command="2" class="login-title">终端入驻</el-dropdown-item>
                        <el-dropdown-item command="3" class="login-title">业务员入驻</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
                <div v-show="showSelfDropMenu" class="dropdown-menu-self">
                    <div
                        v-for="(item, index) in columns"
                        :key="index"
                        class="login-title"
                        @click="handleSelectLogin(item)"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>
            <div v-if="seen" class="header-user" @click.stop="toggleUserMenu">
                <img class="header-user__avatar" :src="displayUserAvatar" alt="头像" />
                <div v-show="showUserMenu" class="header-user__menu">
                    <div class="header-user__info">
                        <img class="header-user__blank" :src="displayUserAvatar" alt="头像" />
                        <div class="header-user__text">
                            <div>{{ displayUserName }}</div>
                            <div>{{ displayUserPhone }}</div>
                        </div>
                    </div>
                    <div v-if="isLoggedIn" class="header-user__logout" @click.stop="logout">
                        退出登录
                    </div>
                    <div v-else class="header-user__logout" @click.stop="goLogin">立即登录</div>
                </div>
            </div>
        </div>
        <div class="container" style="clear: both">
            <router-view></router-view>
        </div>

        <div v-if="!isLoginPage" class="footer">
            <div class="footer-bottom">
                <div
                    v-for="(row, rowIndex) in footerLinkRows"
                    :key="rowIndex"
                    class="footer-bottom-text"
                >
                    <template v-for="(item, itemIndex) in row">
                        <span
                            v-if="itemIndex"
                            :key="`${item.label}-separator`"
                            class="footer-separator"
                            >|</span
                        >
                        <a
                            v-if="item.href"
                            :key="item.label"
                            :href="item.href"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ item.label }}</a
                        >
                        <span v-else :key="item.label">{{ item.label }}</span>
                    </template>
                </div>
            </div>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
            <img src="../assets/back_top.png" style="height: 45px; width: 45px" />
        </div>

        <!-- 扫码入驻 -->
        <el-dialog
            :title="'申请' + activeTitle"
            :visible.sync="showLoginDialog"
            width="380px"
            center
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <div class="login-dialog">
                <div v-if="activeTitle === '工业入驻'" class="tips-1">
                    申请工业入驻，请扫码关注邮你采微信公众号后，在公众号上申请！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-1">
                    请扫下方二维码下载邮你采App，注册成为我们的终端用户，期待您的加入！
                </div>
                <div v-if="activeTitle === '业务员入驻'" class="tips-1">
                    请扫下方二维码下载邮业务App，注册成为我们的业务员，期待您的加入！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-2">
                    申请资格：必须是合规的售药单位才可申请入驻。
                </div>
                <div v-if="activeTitle === '工业入驻'" class="tips-2">
                    或拨打客服电话：15306997110
                </div>
                <img
                    v-if="activeTitle === '工业入驻'"
                    class="code-img"
                    src="../assets/main/yncgzh.png"
                />
                <img
                    v-if="activeTitle === '终端入驻'"
                    class="code-img"
                    src="../assets/qrcode/ync.png"
                />
                <img
                    v-if="activeTitle === '业务员入驻'"
                    class="code-img"
                    src="../assets/qrcode/yyw.png"
                />
                <div class="code-title"></div>
                <div class="close-btn" @click="showLoginDialog = false">关 闭</div>
            </div>
        </el-dialog>

        <!-- 移动端弹出层 -->
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </van-popup>
        <!-- 移动端对话框 -->
        <van-dialog v-model="show" :title="'申请' + activeTitle" :showConfirmButton="false">
            <div class="login-dialog">
                <div v-if="activeTitle === '工业入驻'" class="tips-1">
                    申请工业入驻，请扫码关注邮你采微信公众号后，在公众号上申请！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-1">
                    请扫下方二维码下载邮你采App，注册成为我们的终端用户，期待您的加入！
                </div>
                <div v-if="activeTitle === '业务员入驻'" class="tips-1">
                    请扫下方二维码下载邮业务App，注册成为我们的业务员，期待您的加入！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-2">
                    申请资格：必须是合规的售药单位才可申请入驻。
                </div>
                <div v-if="activeTitle === '工业入驻'" class="tips-2">
                    或拨打客服电话：15306997110
                </div>
                <img
                    v-if="activeTitle === '工业入驻'"
                    class="code-img"
                    src="../assets/main/yncgzh.png"
                />
                <img
                    v-if="activeTitle === '终端入驻'"
                    class="code-img"
                    src="../assets/qrcode/ync.png"
                />
                <img
                    v-if="activeTitle === '业务员入驻'"
                    class="code-img"
                    src="../assets/qrcode/yyw.png"
                />
                <div class="code-title">单击识别二维码</div>
                <div class="close-btn" @click="show = false">关 闭</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { imgUrl } from '@/utils/setting'

export default {
    name: 'Layout',
    data() {
        return {
            activeIndex: '1',
            scroll: '',
            timer: '',
            currentMenu: '首页',
            contactPhone: '15306997110',
            activeTitle: '',
            showLoginDialog: false,
            showPicker: false,
            columns: ['工业入驻', '终端入驻', '业务员入驻'],
            show: false,
            showSelfDropMenu: false,
            showUserMenu: false,
            userInfo: null,
            footerLinkRows: [
                [
                    {
                        label: '互联网药品信息服务资格证书编号：(闽)-经营性-2023-0023',
                        href: '/zj/internet-drug-info-service.png'
                    },
                    {
                        label: '增值电信业务经营许可证：闽B2-20230807',
                        href: '/zj/value-added-telecom-license.pdf'
                    },
                    {
                        label: '药品网络交易第三方平台备案证：(闽)网药平台备字(2023)第000007-004号',
                        href: '/zj/drug-online-third-party-platform.pdf'
                    }
                ],
                [
                    {
                        label: '(闽)网械平台备字[2023]第00013号',
                        href: '/zj/medical-device-platform-record.png'
                    },
                    {
                        label: '省内网络食品交易第三方平台提供者信息备案',
                        href: 'https://220.160.53.129:8192/lic-online-pub-front/nsfsProInDetail?licID=2e1fc3f058fa4beed9862aebb67c2ca5'
                    },
                    {
                        label: '闽ICP备2023004715号-1',
                        href: 'https://beian.miit.gov.cn'
                    },
                    {
                        label: '营业执照',
                        href: '/zj/business-license.png'
                    },
                    {
                        label: 'Copyright © 福建邮你采科技有限公司',
                        href: ''
                    }
                ]
            ]
        }
    },
    watch: {
        $route: {
            handler() {
                this.backTop()
            }
        }
    },
    computed: {
        isLoginPage() {
            return this.$route.meta && this.$route.meta.hideLayoutChrome
        },
        activeNavName() {
            return this.$route.name === 'NewsDetail' ? 'News' : this.$route.name
        },
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        },
        isLoggedIn() {
            return Boolean(this.userInfo && this.userInfo.access_token)
        },
        displayUserAvatar() {
            return (this.userInfo && this.userInfo.headImg) || `${imgUrl}/personal/icon_tx@2x.png`
        },
        displayUserName() {
            if (!this.isLoggedIn) return '未登录'
            return (
                this.userInfo.nickName ||
                this.userInfo.realName ||
                this.userInfo.userName ||
                '邮你采用户'
            )
        },
        displayUserPhone() {
            if (!this.isLoggedIn) return '登录后查看'
            return this.userInfo.mobile || ''
        }
    },
    mounted() {
        this.loadUserInfo()
        window.addEventListener('scroll', this.handleScroll)
        document.addEventListener('click', this.hideBox)
        window.addEventListener('youcai-user-change', this.loadUserInfo)
    },
    destroyed() {
        clearInterval(this.timer)
        window.removeEventListener('scroll', this.handleScroll)
        document.removeEventListener('click', this.hideBox)
        window.removeEventListener('youcai-user-change', this.loadUserInfo)
    },
    methods: {
        // web端导航
        handleSelect(key) {
            switch (key) {
                case 'Home':
                    this.$router.push({ name: 'Home' })
                    break
                case 'Profile':
                    this.$router.push({ name: 'Profile' })
                    break
                case 'Product':
                    this.$router.push({ name: 'Product' })
                    break
                case 'Contact':
                    this.$router.push({ name: 'Contact' })
                    break
                case 'News':
                    this.$router.push({ name: 'News' })
                    break
                case 'ShoppingMall':
                    this.openShoppingMall()
                    break
            }
        },
        // 移动端导航
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'Home' })
                    // this.currentMenu='首页'
                    break
                case '2':
                    this.$router.push({ name: 'Profile' })
                    break
                case '3':
                    this.$router.push({ name: 'Product' })
                    break
                case '4':
                    this.$router.push({ name: 'Contact' })
                    break
                case '5':
                    this.$router.push({ name: 'News' })
                    break
                case '6':
                    this.openShoppingMall()
                    break
            }
        },
        openShoppingMall() {
            window.open(process.env.VUE_APP_SHOPPING_MALL_URL, '_blank')
        },
        handleSelectLogin(key) {
            this.activeTitle = key
            this.showLoginDialog = true
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop //获取滚动后的高度
            if (this.scroll > 400) {
                //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block'
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop() {
            //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },

        register() {
            this.showPicker = true
        },

        logoClick() {
            this.$router.push({ name: 'Home' })
            this.currentMenu = '首页'
            // this.$refs.menu.activeIndex = '1'
        },

        onConfirm(val) {
            this.activeTitle = val
            this.showPicker = false
            this.show = true
        },

        hideBox(e) {
            if (this.$refs.box != undefined && !this.$refs.box.contains(e.target)) {
                this.showSelfDropMenu = false
            }
            this.showUserMenu = false
        },

        loadUserInfo() {
            try {
                const rawUser = localStorage.getItem('youcai_user')
                this.userInfo = rawUser ? JSON.parse(rawUser) : null
            } catch (error) {
                this.userInfo = null
            }
        },

        toggleUserMenu() {
            this.showUserMenu = !this.showUserMenu
            this.showSelfDropMenu = false
        },

        goLogin() {
            this.showUserMenu = false
            this.$router.push({
                name: 'Login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },

        logout() {
            localStorage.removeItem('youcai_user')
            this.userInfo = null
            this.showUserMenu = false
            if (this.$route.name === 'Login') return
            this.$message.success('已退出登录')
        }
    }
}
</script>

<style scoped lang="scss">
.el-menu--horizontal > .el-menu-item {
    border: none;
}
.logo_img {
    width: 40%;
    cursor: pointer;
}
#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer;
}
.header-title {
    font-size: 1em;
}
.company_name {
    font-weight: normal;
    font-size: 1em;
}
.footer_font {
    font-size: 1em;
}
#menu_index {
    width: 37%;
    // width: 600px;
}
.el-menu-demo {
    font-weight: bold;
    line-height: 22px;
    width: 100%;
    height: 100%;
}
.el-menu-item {
    width: 16%;
    text-align: center;
}
.header {
    margin: 0 auto;
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
}
#header-img {
    width: 174px;
    height: 54px;
    float: left;
    margin: auto;
}
.header-logo {
    width: 175px;
    height: 56px;
    align-self: center;
    float: right;
    // margin-left: 50%;
    margin-right: 12%;
}
.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    width: 100%;
    color: #ffffff;

    .footer-bottom {
        box-sizing: border-box;
        width: 100%;
        min-height: 137px;
        background-color: #20282d;
        border-top: 10px solid #293137;
        padding: 38px 20px 30px;

        &-text {
            width: 100%;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 17px;
            text-align: center;
            word-break: break-word;

            & + .footer-bottom-text {
                margin-top: 8px;
            }

            a {
                color: #ffffff;
            }
        }
    }

    .footer-separator {
        margin: 0 5px;
    }
}

a {
    text-decoration: none;
}
a:visited {
    text-decoration: none;
}
a:hover {
    text-decoration: none;
}
a:active {
    text-decoration: none;
}

.header-login {
    display: flex;
    flex-direction: column;
    padding-top: 5px;
    position: relative;
    margin-left: 20px;
}

.phone-number {
    display: flex;
    align-items: center;
}

.phone-number-img {
    width: 18px;
    height: 18px;
    margin-right: 2px;
}

.dropdown-menu-self {
    width: 100%;
    position: absolute;
    z-index: 99;
    left: 0;
    bottom: -125px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
    border-radius: 5px;
    .login-title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        &:hover {
            color: #2f9458;
            background: #cbe9d6;
            cursor: pointer;
        }
    }
}

.header-login-btn {
    margin-top: 6px;
    background-color: #2f9458;
    color: #fff;
    border: #2f9458;
    width: 128px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    font-size: 0.875rem;
    line-height: 30px;

    &:hover {
        cursor: pointer;
    }
}

.header-user {
    position: relative;
    width: 58px;
    height: 58px;
    margin-left: 22px;
    cursor: pointer;
}

.header-user__avatar {
    display: block;
    box-sizing: border-box;
    width: 58px;
    height: 58px;
    border: 1px solid #a5a5a5;
    border-radius: 50%;
    background: #dddddd;
    object-fit: cover;
}

.header-user__menu {
    position: absolute;
    top: 56px;
    right: 0;
    z-index: 120;
    box-sizing: border-box;
    width: 226px;
    min-height: 134px;
    border: 1px solid #999999;
    background: #ffffff;
    padding: 15px 18px 13px;
}

.header-user__info {
    display: flex;
    align-items: center;
}

.header-user__blank {
    display: block;
    box-sizing: border-box;
    width: 60px;
    height: 60px;
    flex: 0 0 auto;
    border: 1px solid #b4b4b4;
    border-radius: 50%;
    background: #ffffff;
    object-fit: cover;
}

.header-user__text {
    min-width: 0;
    margin-left: 14px;
    color: #4e4e4e;
    font-size: 18px;
    line-height: 22px;
}

.header-user__text div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-user__logout {
    margin-top: 25px;
    color: #ff4d4f;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
}

.header-user__logout:hover {
    color: #d9363e;
}

.login-dialog {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.75rem;
    color: #333333;
    line-height: 17px;

    .title {
        font-size: 1rem;
        line-height: 22px;
        font-weight: bold;
        margin-bottom: 18px;
    }

    .tips-1 {
        width: 268px;
        line-height: 17px;
        margin-bottom: 6px;
    }
    .tips-2 {
        width: 268px;
        line-height: 17px;
        color: #15803c;
    }
    .code-img {
        width: 126px;
        height: 126px;
        margin-top: 18px;
    }
    .code-title {
        margin-top: 12px;
        margin-bottom: 16px;
    }

    .close-btn {
        width: 208px;
        height: 36px;
        background: #2f9458;
        box-shadow: 0px 3px 10px 0px rgba(22, 138, 26, 0.22);
        border-radius: 4px;
        font-size: 0.875rem;
        color: #ffffff;
        text-align: center;
        line-height: 36px;

        &:hover {
            cursor: pointer;
        }
    }
}

::v-deep .el-dialog__body {
    padding: 0 16px 16px 16px;
}
// ::v-deep .el-icon-close:before {
//     content: '';
// }
::v-deep .el-dialog {
    border-radius: 5px;
}

@media screen and (max-device-width: 768px) {
    .header {
        height: 44px;
        position: relative;

        .header-logo {
            width: 78px;
            height: 25px;
            margin-left: 16px;
        }

        #header-img {
            width: 78px;
            height: 25px;
        }

        .header-login-btn {
            width: 68px;
            height: 24px;
            line-height: 24px;
            background: #157e3b;
            border-radius: 3px;
            position: absolute;
            top: 5px;
            right: 49px;
            &.el-button {
                padding: 0 5px;
            }
        }

        .menu-img {
            width: 24px;
            height: 24px;
        }
        .el-menu-demo {
            // position: absolute;
            // .c-menu {
            //     font-size: .8125rem;
            //     line-height: 18px;
            // }
            // .e-menu {
            //     font-size: .5625rem;
            //     line-height: 13px;
            // }
        }

        #menu_index {
            position: absolute;
            top: 10px;
            right: 13px;
            width: 24px;
        }
    }

    .header-title {
        border-bottom: 1px solid #e9e9e9;
        padding-bottom: 6px;
        padding-top: 6px;
        .c-menu {
            font-size: 0.8125rem;
            line-height: 18px;
            text-align: center;
        }
        .e-menu {
            font-size: 0.5625rem;
            line-height: 13px;
            margin-top: 2px;
            text-align: center;
        }
    }

    .menu-color {
        color: #157e3b;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer;
        z-index: 999;
    }

    .footer {
        width: 100%;

        .footer-bottom {
            min-height: 0;
            padding: 18px 14px;

            &-text {
                font-size: 0.75rem;
                line-height: 19px;
            }
        }
    }
    .footer_font {
        font-size: 0.875em;
    }

    .login-dialog {
        .tips-1 {
            margin-top: 15px;
        }
        .close-btn {
            margin-bottom: 17px;
        }
    }
}

@media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
    .logo_img {
        width: 30%;
    }

    #menu_index {
        width: 50%;
    }
}
</style>
